<div class="spacer-bottom">

<h2>Bildgebende Verfahren</h2>

<h3>Verfahren</h3>

<tags-input ng-model="vm.imagingconfig.values"
            display-property="name"
            placeholder="Neues bildgebendes Verfahren hinzufügen ..."
            replace-spaces-with-dashes="false"
            add-on-comma="false"
            min-length="1"
            on-tag-added="vm.saveConfig()"
            on-tag-removed="vm.saveConfig()"
            template="tag-template">
    <auto-complete source="vm.loadValues($query)"
                   min-length="0"
                   load-on-focus="true"
                   load-on-empty="true"
                   max-results-to-show="32"
                   template="autocomplete-template"></auto-complete>
</tags-input>


<h3>Neue Gruppe</h3>


<form>
    <div class="input-group">
        <input class="form-control"
               ng-model="vm.newgroup" id="newgroup" placeholder="Neue Laborwertgruppe"/>
        <span class="input-group-btn">
          <button class="btn btn-success"
                  type="submit"
                  ng-click="vm.addGroup()"><i class="fa fa-plus"></i> Neue Gruppe anlegen</button>
        </span>
    </div>
</form>

<h3>Gruppen</h3>
<form class="form-vertical">
    <div ng-repeat="group in vm.imagingconfig.groups" class="spacer-top">
        <div class="row">
        <div class="col-xs-12">
            <span class="pull-left" ng-bind="group.name" style="font-weight: bold; padding-top: 20px"></span>
            <span class="pull-right">
                <span class="btn btn-danger btn-sm"
                      ng-click="vm.removeGroup($index)"
                      style="margin-top: 2ex; margin-bottom: 0.8ex;"><i class="fa fa-remove"></i> Gruppe löschen
                </span>
            </span>
        </div>
        </div>
        <div class="row">
        <div class="col-xs-12">
            <tags-input ng-model="group.values"
                        display-property="name"
                        placeholder="Tippen zum Vervollständigen"
                        replace-spaces-with-dashes="false"
                        ng-blur="vm.saveConfig()"
                        add-on-comma="false"
                        min-length="1"
                        tabindex="0"
                        enable-editing-last-tag="true"
                        on-tag-removed="vm.saveConfig()"
                        template="tag-template">
                <auto-complete source="vm.loadValues($query)"
                               min-length="0"
                               load-on-focus="false"
                               load-on-down-arrow="true"
                               load-on-empty="true"
                               max-results-to-show="32"
                               template="autocomplete-template"></auto-complete>
            </tags-input>
        </div>
        </div>
    </div>
    <script type="text/ng-template" id="tag-template">
        <div class="tag-template">
            <div class="right-panel">
                <span>{{$getDisplayText()}}</span>
                <a class="remove-button" ng-click="$removeTag()">&#10006;</a>
            </div>
        </div>
    </script>


    <script type="text/ng-template" id="autocomplete-template">
        <div class="autocomplete-template">
            <div>
                <span ng-bind-html="$highlight($getDisplayText())">{{name}}</span>
            </div>
        </div>
    </script>

</form>
</div>